import React from 'react';
import './buttonWithSubHeading.scss';

class ButtonWithSubHeading extends React.Component {

    render() {
        return (
            <button className="inner-shadow-btn-wsh" onClick={e=>{
                e.preventDefault();
                this.props.clicked(e);
    }} color="primary" size="lg">{this.props.title ? this.props.title : 'Button'}<br /><p>{this.props.subTitle ? this.props.subTitle : '...'}</p></button>
        );
    }
}

export default ButtonWithSubHeading;
